import { render, staticRenderFns } from "./DevRolesConfigurator.vue?vue&type=template&id=0062fc02&scoped=true"
import script from "./DevRolesConfigurator.vue?vue&type=script&lang=js"
export * from "./DevRolesConfigurator.vue?vue&type=script&lang=js"
import style0 from "./DevRolesConfigurator.vue?vue&type=style&index=0&id=0062fc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062fc02",
  null
  
)

export default component.exports